import { Link } from 'react-router-dom';

/**
 * Wordmark logo for AutoTrust.
 * Pure typography + a tight "AT" monogram square in brushed gold.
 * No emoji, no shield icon — Fortune-500 minimalism.
 */
export default function Logo({ size = 'md', linkTo = '/', dataTestId = 'logo' }) {
  const dims = {
    sm: { box: 'w-7 h-7', text: 'text-base', mono: 'text-[10px]' },
    md: { box: 'w-9 h-9', text: 'text-lg', mono: 'text-xs' },
    lg: { box: 'w-12 h-12', text: 'text-2xl', mono: 'text-base' },
  }[size] || { box: 'w-9 h-9', text: 'text-lg', mono: 'text-xs' };

  const inner = (
    <div className="flex items-center gap-2.5 group" data-testid={dataTestId}>
      <div
        className={`${dims.box} relative rounded-md bg-gold flex items-center justify-center transition-transform duration-200 group-hover:scale-105`}
      >
        <span
          className={`${dims.mono} font-bold text-black tracking-tight font-mono-display leading-none`}
          aria-hidden="true"
        >
          AT
        </span>
        {/* brushed-metal shimmer */}
        <span className="pointer-events-none absolute inset-0 rounded-md bg-gradient-to-br from-white/25 via-transparent to-black/15" />
      </div>
      <span className={`${dims.text} font-bold tracking-tight leading-none hidden sm:inline`}>
        AutoTrust<span className="text-emerald">.</span>
      </span>
    </div>
  );

  if (!linkTo) return inner;
  return (
    <Link to={linkTo} className="flex-shrink-0">
      {inner}
    </Link>
  );
}
